import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, withDirectives as _withDirectives, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-b0d50638"), n = n(), _popScopeId(), n);

const _hoisted_1 = ["title"];
const _hoisted_2 = {
  key: 1,
  style: {
    "color": "#999"
  }
};
const _hoisted_3 = {
  key: 0,
  class: "unselected",
  style: {
    "background-color": "#777",
    "color": "#fff",
    "display": "flex",
    "justify-content": "flex-end",
    "align-items": "center",
    "border-left": "1px solid #000",
    "border-right": "1px solid #000",
    "border-bottom": "1px solid #000",
    "padding": "0 0.5rem"
  }
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "全选", -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    ref: $options.selectRef,
    style: {
      "width": "100%",
      "height": "100%",
      "display": "flex",
      "flex-wrap": "wrap",
      "cursor": "pointer"
    }
  }, [_createElementVNode("div", {
    class: _normalizeClass({
      disabled: $props.disabled
    }),
    style: {
      "width": "100%",
      "height": "100%",
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center",
      "border": "1px solid #000",
      "padding": "0 0.5rem"
    },
    onClick: _cache[0] || (_cache[0] = $event => $options.clickSelect())
  }, [$data.showArr.join() != '' ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "title-self",
    title: $data.showArr.join()
  }, _toDisplayString($data.showArr.join()), 9, _hoisted_1)) : (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString($props.placeholder), 1)), _createElementVNode("div", {
    class: _normalizeClass(["bi", $data.fold ? 'bi-caret-down' : 'bi-caret-up'])
  }, null, 2)], 2), _withDirectives(_createElementVNode("div", {
    style: {
      "position": "fixed",
      "left": "0",
      "top": "0",
      "width": "100vw",
      "height": "100vh",
      "background-color": "rgba(0,0,0,0)",
      "z-index": "990"
    },
    onClick: _cache[3] || (_cache[3] = _withModifiers($event => $data.fold = true, ["stop"])),
    onMousewheel: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
  }, [_createElementVNode("div", {
    ref: $options.optionsRef,
    style: _normalizeStyle([{
      'left': $data.optionsLeft + 'px',
      'top': $data.optionsTop + 'px'
    }, {
      "border": "2px solid #777",
      "position": "absolute",
      "width": "fit-content",
      "z-index": "991",
      "overflow": "hidden auto"
    }])
  }, [$props.selectAll ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_withDirectives(_createElementVNode("input", {
    type: "checkbox",
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.checkShow = $event),
    onClick: _cache[2] || (_cache[2] = _withModifiers($event => $options.clickCheckAll(), ["stop"]))
  }, null, 512), [[_vModelCheckbox, $data.checkShow]]), _hoisted_4])) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "default", {}, undefined, true)], 4)], 544), [[_vShow, !$data.fold]])], 512);
}